import { useMemo } from "react";

export default function Atmosphere() {
  const motes = useMemo(() => Array.from({ length: 18 }, (_, index) => ({
    id: index,
    left: `${(index * 37) % 100}%`,
    top: `${(index * 61) % 100}%`,
    delay: `${(index % 7) * -1.3}s`,
    duration: `${8 + (index % 6) * 2}s`,
  })), []);

  return (
    <div className="atmosphere" aria-hidden="true">
      <div className="aurora aurora-gold" />
      <div className="aurora aurora-violet" />
      {motes.map((mote) => <i key={mote.id} style={mote} />)}
    </div>
  );
}
